export default __webpack_public_path__ + "static/inrupi-a824734f24ec2a3aa18392f550c7e546.svg";